var _path, _path2, _mask, _rect, _path3, _mask2, _rect2, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgListInputIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0151 1.09766H1.7193C0.972549 1.09766 0.367188 1.70302 0.367188 2.44977V23.7455C0.367188 24.4923 0.972549 25.0977 1.7193 25.0977H23.0151C23.7618 25.0977 24.3672 24.4923 24.3672 23.7455V2.44977C24.3672 1.70302 23.7618 1.09766 23.0151 1.09766Z",
    stroke: "#D9D9D9",
    strokeWidth: 0.334473
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8698 19.7656H3.86979C3.77774 19.7656 3.70312 19.8402 3.70312 19.9323C3.70312 20.0243 3.77774 20.099 3.86979 20.099H20.8698C20.9618 20.099 21.0365 20.0243 21.0365 19.9323C21.0365 19.8402 20.9618 19.7656 20.8698 19.7656Z",
    fill: "#D9D9D9"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_46699_258014",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.36719,
    y: 5.76562,
    width: 4.68262,
    height: 4.68262,
    rx: 0.668945
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.36719,
    y: 5.76562,
    width: 4.68262,
    height: 4.68262,
    rx: 0.668945,
    stroke: "#4D4D4D",
    strokeWidth: 1.67236,
    mask: "url(#path-3-inside-1_46699_258014)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0547 8.10547H17.7441",
    stroke: "#4D4D4D",
    strokeWidth: 0.903076,
    strokeLinecap: "round"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-2_46699_258014",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.36719,
    y: 11.7852,
    width: 4.68262,
    height: 4.68262,
    rx: 0.668945
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.36719,
    y: 11.7852,
    width: 4.68262,
    height: 4.68262,
    rx: 0.668945,
    stroke: "#4D4D4D",
    strokeWidth: 1.67236,
    mask: "url(#path-5-inside-2_46699_258014)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0547 14.125H17.7441",
    stroke: "#4D4D4D",
    strokeWidth: 0.836182,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListInputIcon);
export default __webpack_public_path__ + "static/media/list-input-icon.5f72c16ba09ce5b5373988fdc0122832.svg";
export { ForwardRef as ReactComponent };